import DefaultNavbar from 'components/DefaultNavbar';
import DefaultFooter from 'components/DefaultFooter';

import TestimonialSection from 'components/landing/TestimonialSection';

export default function Testimonials() {
    return (
        <>
            <DefaultNavbar />
            <main>
                <TestimonialSection />
            </main>
            <DefaultFooter />
        </>
    );
}